import * as scormAPIWrapper from '../wrappers/scorm/APIWrap';
import * as scormConstants from '../constants/scormConstants';
import * as appData from '../models/appModels';
import {setStudentName} from '../helpers/appHelper';
import * as localeStorage from '../localStorage/localStorage';

class ScormService {

    static initTracking() {
       //console.log('initTracking');
        return new Promise(function (resolve, reject) {
            let trackingData = Object.assign({}, appData.TRACKING_DATA);
            scormAPIWrapper.doLMSInitialize().then(result => {

                //GET SUSPEND_DATA
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_SUSPEND_DATA).then(result => {
                    let suspend_data = result.data;
                    if(suspend_data.length > 0){
                        suspend_data = JSON.parse(suspend_data);
                    }
                   //console.log('Get suspend_data ', result.data);
                    trackingData = Object.assign({}, trackingData, {
                        suspend_data: result.success ? suspend_data : trackingData.suspend_data
                    });

                }).catch(error => {
                    throw(error);
                });

                //GET STUDENT_NAME
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_STUDENT_NAME).then(result => {
                    if(result.success){
                        let studentNameObj = setStudentName(result.data);
                        trackingData = Object.assign({}, trackingData, {
                            student_name: studentNameObj.student_name,
                            first_name: studentNameObj.first_name,
                            last_name: studentNameObj.last_name
                        });
                    }
                }).catch(error => {
                    throw(error);
                });

                //GET LESSON_LOCATION (BOOKMARK)
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_LOCATION).then(result => {
                    trackingData = Object.assign({}, trackingData, {
                        lesson_location: result.success &&  !isNaN(result.data)? parseInt(result.data) : 0
                    });

                }).catch(error => {
                    throw(error);
                });

                //GET LESSON_STATUS
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_STATUS).then(result => {

                    if (result.data != scormConstants.LESSON_STATUS_COMPLETED) {
                        scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_STATUS, scormConstants.LESSON_STATUS_INCOMPLETE);
                        trackingData = Object.assign({}, trackingData, {
                            lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
                        });
                    }else{
                        trackingData = Object.assign({}, trackingData, {
                            lesson_status: result.success ? result.data : trackingData.lesson_status
                        });
                    }

                }).catch(error => {
                    throw(error);
                });

                //GET SCORE_RAW
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_SCORE_RAW).then(result => {
                    trackingData = Object.assign({}, trackingData, {
                        score_raw: result.success && !isNaN(parseInt(result.data)) ? parseInt(result.data) : trackingData.score_raw
                    });
                }).catch(error => {
                    throw(error);
                });


                //FINISH OFF BY MAKING SURE THE LMS IS INITIALISED
                scormAPIWrapper.LMSIsInitialized().then(result => {

                    trackingData = Object.assign({}, trackingData, {
                        initialised: result.success && result.data == "true" ? true : trackingData.initialised
                    });
                    resolve(trackingData);
                }).catch(error => {
                    resolve(trackingData);
                });

            }).catch(error => {
                if (appData.SETTINGS.DEVELOPMENT_MODE) {
                    const student_name = "Lastname, Firstname";
                    let studentNameObj = setStudentName(student_name);

                    trackingData = Object.assign({}, trackingData, {
                        initialised: true,
                        student_name: studentNameObj.student_name,
                        first_name: studentNameObj.first_name,
                        last_name: studentNameObj.last_name
                    });
                    resolve(trackingData);
                } else {
                    throw(error);
                }

            });

        });
    }

    static setLessionLocation(lesson_location){
       if(!isNaN(lesson_location)) {
           return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_LOCATION, lesson_location.toString());
       }else{
           return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_LOCATION, localeStorage.contentData.experience.bites[0].screens[0].screen_id.toString());
       }
    }

    static setSuspendData(suspend_data){

       //console.log('Set suspend_data ', JSON.stringify(suspend_data));
        return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_SUSPEND_DATA, JSON.stringify(suspend_data));
    }

    static setLessionStatus(lesson_status){
       //console.log('setLessionStatus');
        return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_STATUS, lesson_status);
    }

    static setScoreRaw(scoreRaw){
      // console.log(`setScoreRaw ${scoreRaw}`);
        return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_SCORE_RAW, scoreRaw);
    }

    static setScoreMin(scoreMin){
      // console.log(`scoreMin ${scoreMin}`);
        return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_SCORE_MIN, scoreMin);
    }

    static setScoreMax(scoreMax){
      // console.log(`scoreMax ${scoreMax}`);
        return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_SCORE_MAX, scoreMax);
    }

    static doLMSFinish() {
       //console.log('doLMSFinish');
        //return scormAPIWrapper.doLMSFinish();
        return new Promise(function (resolve,  reject) {
            scormAPIWrapper.LMSIsInitialized().then(result => {
                if (result.success && result.data === "true") {
                    resolve(scormAPIWrapper.doLMSFinish());
                }
            }).catch(error => {
                //console.log(`doLMSFinish`, error);
                reject(error);
            });
        });
    }


    static doLMSCommit() {
      // console.log('doLMSCommit');
        return new Promise(function (resolve,  reject) {
            scormAPIWrapper.LMSIsInitialized().then(result => {
                if (result.success && result.data === "true") {
                    resolve(scormAPIWrapper.doLMSCommit());
                }
            }).catch(error => {
                //console.log(`doLMSCommit`, error);
                reject(error);
            });
        });

    }

    static doQuickLMSFinish() {
        //console.log('doLMSFinish');
        return scormAPIWrapper.doLMSFinish();
    }

    static doQuickLMSCommit() {
        //console.log('doLMSCommit');
        return scormAPIWrapper.doLMSCommit();
    }

    static lmsGetScore(){
        scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_SCORE_RAW).then(result => {
           // console.log(`lmsGetScore`, result);
        }).catch(error => {
            //console.log(`lmsGetScore error`, error);
        });
    }

    static lmsGetLessonStatus(){
        scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_STATUS).then(result => {
            //console.log(`lmsGetLessonStatus`, result);
        }).catch(error => {
            //console.log(`lmsGetLessonStatus error`, error);
        });
    }

    static doLMSExit(){
        return scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_EXIT, scormConstants.EXIT_SUSPEND);
    }

    /*static doLMSSetValue(name,value){

     return scormAPIWrapper.doLMSSetValue(name,value).then(result => {
     //console.log(result);
     }).catch(error => {
     //console.log(error);
     throw(error);
     });
     }*/
}

export default ScormService;


/** WEBPACK FOOTER **
 ** ./src/services/scormService.js
 **/